import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    theme_color: {
        main: "#531B93",
        secondary: "#9437FF",
    },
    urls: {
        gui: 'https://biotxplorer.sibils.org',
        search: '/api/search',
        fetch: '/api/fetch',
        passages: '/api/passages',
        normalize: '/api/normalize',
    },
    collections: {
        medline: 'MEDLINE', 
        pmc: 'BiodiversityPMC',
        plazi: 'PLAZI',
        suppdata: 'Supplementary data',
        zenodo: 'Zenodo'
    },
    fetch_query: {
        doc_id: '',
        collection: 'medline'
    },
    user_query: {
        taxon1: "",
        taxon1_pt: "",
        taxon1_id: "",
        taxon2: "",
        taxon2_pt: "",
        taxon2_id: "",
        interaction: "",
        interaction_pt: "",
        interaction_id: "",
        reformulated_query: "",
    },
    interactions: {
        medline: [],
        pmc: [],
        plazi: [],
        suppdata: [],
        zenodo: []

     },
    examples: [
        {
            query: "Which taxa interact with pangolins?",
            taxon1: "Pangolin",
            taxon2: "",
            interaction: ""
        },
        {
            query: "What is the interaction between Oncomelania hupensis and Schistosoma japonicum?",
            taxon1: "Oncomelania hupensis",
            taxon2: "Schistosoma japonicum",
            interaction: ""
        },
        {
            query: "Which taxa are host of Biomphalaria glabrata?",
            taxon1: "Biomphalaria glabrata",
            taxon2: "",
            interaction: "host"
        },
        {
            query: "What is the interaction between Phengaris arion and Myrmica sabuleti?",
            taxon1: "Phengaris arion",
            taxon2: "Myrmica sabuleti",
            interaction: ""
        }
    ],
    user_selection: {
        interactions: {
            facets: {
                interaction: [],
                taxon: [],
            },
            sort: 'rank',
        },
        selected_documents: {},
        selected_documents_count: 0
    },
    filters: {
        interactions: {
            sort: ['rank', 'nb of docs', 'nb of passages', 'interaction'],
            facets: [
                {title: 'Interactions', short: 'interaction', multi: true},
                {title: 'Taxa', short: 'taxon', multi: true},
            ],
        }
    },
  },
  mutations: {
    UPDATE_TAXON1(state, value) {
        state.user_query.taxon1 = value
    },
    UPDATE_TAXON2(state, value) {
        state.user_query.taxon2 = value
    },
    UPDATE_INTERACTION(state, value) {
        state.user_query.interaction = value
    },
    UPDATE_RESULTS(state, value) {
        state.interactions[value.collection] = value.interactions
    },
    UPDATE_INTERACTIONS_SORT(state, value){
        state.user_selection.interactions.sort = value
    },
    UPDATE_INTERACTIONS_FACET(state, value){
        state.user_selection.interactions.facets[value.facet] = value.list
    },
    UPDATE_REFORMULATED(state, value){
        state.user_query.reformulated_query = value
    },

    UPDATE_DOC_ID(state, value){
        state.fetch_query.doc_id = value
    },
    UPDATE_COLLECTION(state, value){
        state.fetch_query.collection = value
    },
  },
  actions: {
    updateTaxon1(context, value) {
        context.commit('UPDATE_TAXON1', value)
    },
    updateTaxon2(context, value) {
        context.commit('UPDATE_TAXON2', value)
    },
    updateInteraction(context, value) {
        context.commit('UPDATE_INTERACTION', value)
    },
    updateInteractionsSort(context, value) {
        context.commit('UPDATE_INTERACTIONS_SORT', value)
    },
    updateInteractionsFacet(context, value) {
        context.commit('UPDATE_INTERACTIONS_FACET', value)
    },
    updateResults(context, value) {
        context.commit('UPDATE_RESULTS', value)
     },
     updateReformulated(context, value){
        context.commit("UPDATE_REFORMULATED", value)
     },
     updateDocid(context, value){
        context.commit("UPDATE_DOC_ID", value)
     },
     updateCollection(context, value){
        context.commit("UPDATE_COLLECTION", value)
     },
  },
  modules: {
  }
})
